import React, { useState } from 'react';
import { LandingContent } from 'components/LandingContent';
import leadLandingImage from 'assets/images/leads-landing.png';
import ErrorModal from 'components/Modal/ConfirmationModal';
import { LeadsActionButton } from './Leads.ActionButton';
import { CreateLeadModal } from './CreateLeadForm';

import './styles.scss';

const LeadLanding = ({ statuses }) => {
  const isEmpty = true;
  const [newLeadError, setNewLeadError] = useState(false);
  const [newLeadModalOpen, setNewLeadModalOpen] = useState(false);

  const landContent = () => (
    <>
      Track all of your new leads and manage every last detail&mdash;from first
      contact to final contract&mdash;all right here. Get started with a
      {' '}<a
        target="_blank"
        rel="noreferrer"
        href="https://help.aisleplanner.com/en/articles/1901871-an-intro-to-the-lead-manager"
      >
        <span>quick tour</span>
      </a> of your lead manager, then dive right in and add your first lead below.
    </>
  );

  return (
    <div className="leads-table leads-table--landing">
      <section className="page-title page-title--actions">
        <h1 className="title">Leads</h1>
        <div className="page-title__actions">
          <LeadsActionButton
            statuses={statuses}
            isEmpty={isEmpty}
          />
        </div>
      </section>
      <LandingContent
        action={() => setNewLeadModalOpen(true)}
        title="Get started with your lead manager."
        description={landContent()}
        actionButtonTitle="Create a Lead"
        heroImage={leadLandingImage}
      />
      {newLeadError && (
        <ErrorModal
          visible={newLeadError}
          onClose={() => setNewLeadError(false)}
          actions={(
            <button
              onClick={() => setNewLeadError(false)}
              className="button"
            >
              Close
            </button>
          )}
        >
          <p>
            New lead couldn't be created. Please try again.
          </p>
        </ErrorModal>
      )}
      <CreateLeadModal
        isOpen={newLeadModalOpen}
        dismiss={() => setNewLeadModalOpen(false)}
      />
    </div>
  );
};

export default LeadLanding;
